/*
 * @Author: kangzhuang 742291831@qq.com
 * @Date: 2025-04-07 17:25:00
 * @LastEditors: kangzhuang 742291831@qq.com
 * @LastEditTime: 2025-04-16 13:13:19
 * @FilePath: \look-exhibition-hall\src\api\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import * as user from "./user";
import * as code from "./code";

export default {
	...user,
	...code
};
